/* eslint import/prefer-default-export: "off" */

// TODO: generate URL for assets/loader.gif
export default {
  loading: '',
  swatch: 'https://cdn.shopify.com/s/files/1/0073/9812/t/107/assets/color_50x.png',
};
